module.exports = __webpack_public_path__ + "static/media/slider4.2f9d7c12.png";